import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page73() {
  useEffect(() => {
    document.title = "Маяк — Страница 72"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page71" />
        <ForwardLink href="/page73" />
      </div>

      <p style={{ textAlign: "right" }}>72.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Томас.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Да?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Нет, Томас.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Да.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Нет, Я... Я Томас.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Я Томас. А ты Эфраим.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я солгал.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Чтоб мне захлебнуться.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Я Томас. Томми.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Томми?<br/>
        (смеется)<br/>
        Томми Уинслоу.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Том Ховард.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        А кто же тогда Уинслоу?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Никто.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Никто?
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Это не моя вина... Я...
      </p>
      <p>Пауза.</p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ (ПРОДОЛЖЕНИЕ)<br/>
        Нет.
      </p>
      <p>Пауза.</p>
      <p style={{ textAlign: "right" }}>72.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page71" />
        <ForwardLink href="/page73" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710633788/the-lighthouse-script/ckowsgueloqvbhyrer8c.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page73;
